
 <section class="container mt-5">
    <div class="row">
        <div class="col-md-12">
            <h6 id="h6">PLANNING YOUR TRIP TO</h6>
        </div>
        <div class="col-md-6">
            <button type="button" id="btn" class="btn btn-outline-secondary">Europe</button>
            &nbsp;&nbsp;
            <button type="button" id="btn" class="btn btn-outline-secondary">6 - 9 Days</button>
            &nbsp;&nbsp;
            <button type="button" id="btn" class="btn btn-outline-secondary">
                Adventure & Outdoor </button>
        </div>
        <div class="col-md-6">
            <i class="fa fa-close" id="times"></i>
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-2">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-2">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-2">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgba(44, 47, 66, 0.2);">
        </div>
        <div class="col-md-12">
            <form class="example">
                <input type="text" placeholder="Find a city...">
                <button type="submit"><i class="fa fa-search"></i></button>
            </form>
        </div>
        <div class="col-md-12">
            <h4 id="h4">Cities best connected to Ibiza...</h4>
        </div>
        <div class="col-md-3">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/customizeview">
                    <div style="text-align: center;margin-top: 20px;">
                        <img src="assets/images/11.jpg" style="width: 100px;height: 100px;
                        border-radius: 50%;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom:20px;">
                        <p id="par">Madrid, Spain</p>
                        <p id="par1">Art, Culture and NightClubs
                        <span id="span">AFFORDABLE</span></p>
                    </div>
                    <div style="text-align: center;">
                        <button type="button" id="btn" class="btn btn-default">Theme Parks</button>
                        &nbsp;&nbsp;
                        <button type="button" id="btn" class="btn btn-default">Must See</button>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/customizeview">
                    <div style="text-align: center;margin-top: 20px;">
                        <img src="assets/images/11.jpg" style="width: 100px;height: 100px;
                        border-radius: 50%;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom:20px;">
                        <p id="par">Madrid, Spain</p>
                        <p id="par1">Art, Culture and NightClubs
                        <span id="span">AFFORDABLE</span></p>
                    </div>
                    <div style="text-align: center;">
                        <button type="button" id="btn" class="btn btn-default">Theme Parks</button>
                        &nbsp;&nbsp;
                        <button type="button" id="btn" class="btn btn-default">Must See</button>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/customizeview">
                    <div style="text-align: center;margin-top: 20px;">
                        <img src="assets/images/11.jpg" style="width: 100px;height: 100px;
                        border-radius: 50%;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom:20px;">
                        <p id="par">Madrid, Spain</p>
                        <p id="par1">Art, Culture and NightClubs
                        <span id="span">AFFORDABLE</span></p>
                    </div>
                    <div style="text-align: center;">
                        <button type="button" id="btn" class="btn btn-default">Theme Parks</button>
                        &nbsp;&nbsp;
                        <button type="button" id="btn" class="btn btn-default">Must See</button>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card" style="border-radius:10px;">
                <div class="card-body"><a href="/customizeview">
                    <div style="text-align: center;margin-top: 20px;">
                        <img src="assets/images/11.jpg" style="width: 100px;height: 100px;
                        border-radius: 50%;" >
                    </div>
                    <div style="text-align: center;margin-top: 50px;margin-bottom:20px;">
                        <p id="par">Madrid, Spain</p>
                        <p id="par1">Art, Culture and NightClubs
                        <span id="span">AFFORDABLE</span></p>
                    </div>
                    <div style="text-align: center;">
                        <button type="button" id="btn" class="btn btn-default">Theme Parks</button>
                        &nbsp;&nbsp;
                        <button type="button" id="btn" class="btn btn-default">Must See</button>
                    </div></a>
                </div>
            </div>
        </div>
    </div>
 </section>